import axios from "axios";
import { BASE_URL } from "../../src/utils/api_base_url_configration";

export const loginServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "user/admin-login", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
